import type { ReactNode } from 'react';

import { Icon } from '@repo/ui';

export interface Tab {
  id: string;
  label: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  content?: ReactNode;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
  navigationClassName?: string;
  contentClassName?: string;
}

export function TabNavigation({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  navigationClassName = '',
  contentClassName,
}: TabNavigationProps) {
  // Extract navigation items (without content) for navigation buttons
  const navigationItems = tabs.map(({ content, ...tab }) => tab);

  // Find active tab's content if it exists
  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <div className={className}>
      {/* Tab Navigation Buttons */}
      <div
        className={`flex space-x-1 bg-xtnd-dark-50 dark:bg-xtnd-dark-800 border border-xtnd-dark-100 dark:border-xtnd-dark-600 p-1 rounded-lg w-fit ${navigationClassName}`}
      >
        {navigationItems.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center ${
              activeTab === tab.id
                ? 'bg-xtnd-blue text-white'
                : 'text-xtnd-dark-500 hover:text-xtnd-dark dark:text-xtnd-dark-200 dark:hover:text-xtnd-blue'
            }`}
          >
            {tab.icon && tab.iconPosition !== 'right' && (
              <Icon name={tab.icon as any} className="h-4 w-4 inline mr-2" />
            )}
            {tab.label}
            {tab.icon && tab.iconPosition === 'right' && (
              <Icon name={tab.icon as any} className="h-4 w-4 inline ml-2" />
            )}
          </button>
        ))}
      </div>

      {/* Tab Content - Only render if content exists */}
      {activeTabData?.content !== undefined && (
        <div className={contentClassName}>{activeTabData.content}</div>
      )}
    </div>
  );
}

